import type { FuseSettingsConfigType } from "@fuse/core/FuseSettings/FuseSettings";
import type { RouteObject } from "react-router";
import type { User } from "@auth/user";
import type { PartialDeep } from "type-fest";

export type FuseRouteItemType = RouteObject & {
	auth?: string[] | [];
	settings?: PartialDeep<FuseSettingsConfigType>;
	children?: FuseRouteItemType[];
};

export type FuseRoutesType = FuseRouteItemType[];

class FuseUtils {
	static hasPermission(authArr: string[] | string | undefined, userRole: User["permissoes"]): boolean {
		if (authArr === null || authArr === undefined) return true;

		if (Array.isArray(authArr) && authArr.length === 0) return !userRole || userRole.length === 0;

		if (userRole && Array.isArray(authArr) && Array.isArray(userRole))
			return authArr.some((role) => userRole.includes(role));

		if (typeof userRole === "string" && Array.isArray(authArr)) return authArr.includes(userRole);

		return false;
	}
}

export default FuseUtils;
